<template>
  <div>
    <!-- 一级分销商授权 -->
    <!-- 授权弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="一级分销商授权"
      :visible.sync="authorDialogVisible"
      :before-close="authorHandleClose"
      width="53%"
      center
    >
      <el-divider></el-divider>
      <div class="divider_flex">
        <div class="titleName">
          <span>当前景区:</span>
          <span>{{scenicName}}</span>
        </div>
        <div class="inpt">
          <el-input v-model="authorPar.name"></el-input>
          <el-button type="primary" @click="btns()">查询</el-button>
        </div>
      </div>
      <el-table
        :data="authorData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column prop="Name" label="分销商名称"></el-table-column>
        <el-table-column prop="LinkMan" label="联系人"></el-table-column>
        <el-table-column prop="Phone" label="电话号"></el-table-column>
        <el-table-column prop="E_Mail" label="Email"></el-table-column>
        <el-table-column prop="SCommission" label="景区佣金"></el-table-column>
        <el-table-column prop="DCommission" label="分销商佣金"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text">
              <span v-if="scope.row.is_power==1" class="unaudite" @click="authorFn(scope.row)">取消授权</span>
              <span v-if="scope.row.is_power==2" @click="authorFn(scope.row)">授权</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="authorPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{authorPar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="authorPar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 信息授权弹框开始 -->
    <div v-if="isPower==2">
      <el-dialog :close-on-click-modal="false"
        title="信息"
        :visible.sync="authorSureDialogVisible"
        :before-close="autorSureHandleClose"
        width="24%"
        center
        class="autorDialog"
      >
        <el-divider></el-divider>
        <div class="autorYj">
          <div>
            <img :src="imgAuto" alt />
          </div>
          <div>
            <div class="fswc">确定授权?</div>
            <div class="autorBtn">
              <el-button class="btnCan" type="text" @click="authorCancleTwoFn">取消</el-button>
              <el-button class="btnSure" type="text" @click="authorSureFn">确定</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 信息授权弹框结束 -->
    <!-- 信息授权取消弹框开始 -->
    <div v-if="isPower==1">
      <el-dialog :close-on-click-modal="false"
        title="信息"
        :visible.sync="authorCancleDialogVisible"
        :before-close="autorCancleHandleClose"
        width="24%"
        center
        class="autorDialog"
        top="35vh"
      >
        <el-divider></el-divider>
        <div class="autorYj">
          <div>
            <img :src="imgAuto" alt />
          </div>
          <div>
            <div class="fswc">确定取消授权?</div>
            <div class="autorBtn">
              <el-button class="btnCan" type="text">取消</el-button>
              <el-button class="btnSure" type="text" @click="sureAuthorFn">确定</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 信息授权取消弹框结束 -->

    <!-- 授权弹框结束 -->
  </div>
</template>

<script>
import {
  getDistrbutorTwoListPost,
  impowerDistrbutorTwoPost,
  cancelImpowerDistrbutorTwoPost
} from "@/request/fxs.js";
export default {
  data() {
    return {
      imgAuto: require("@/images/scenics/sqb.png"),
      authorDialogVisible: false, // 主页授权
      authorSureDialogVisible: false, // 授权按钮
      authorCancleDialogVisible: false, // 取消授权
      authorData: [], // 表格数据
      total: 1,
      // 列表数据传参
      authorPar: {
        token: "",
        distrbutor_id: "",
        name:'',
        page: 1,
        page_size: 8
      },
      // 确认授权传参
      authorSurePar: {
        token: "",
        distrbutortwo_id: "",
        distrbutor_id: ""
      },
      // 取消授权确认传参
      // cancalAuthorPar: {
      //   token: "",
      //   distrbutortwo_id: "",
      //   distrbutor_id: ""
      // },

      distrbutorId: "", // 一级分销商id
      distributorTwoId: "", // 二级分销商id
      scenicName: "", // 授权分销商名称
      isPower: "" // 授权/取消授权
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
  },
  methods: {
    btns(){
      console.log(123)
      this.getList(this.authorPar);
    },
    // 取消授权确认
    sureAuthorFn() {
      this.authorSurePar = {
        token: this.Token,
        distrbutortwo_id: this.distributorTwoId,
        distrbutor_id: this.distrbutorId
      };
      cancelImpowerDistrbutorTwoPost(this.authorSurePar).then(res => {
        if (res.data.rcode == 200) {
          this.$message.success(res.data.msg);
          this.authorCancleDialogVisible = false;
          this.getList(this.authorPar);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 点击取消授权关闭弹框X
    autorCancleHandleClose() {
      this.authorCancleDialogVisible = false;
    },

    // 确认授权
    authorSureFn() {
      this.authorSurePar = {
        token: this.Token,
        distrbutortwo_id: this.distributorTwoId,
        distrbutor_id: this.distrbutorId
      };
      impowerDistrbutorTwoPost(this.authorSurePar).then(res => {
        console.log(res);
        if (res.data.rcode == 200) {
          this.$message.success(res.data.msg);
          this.authorSureDialogVisible = false;
          this.getList(this.authorPar);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 点击授权/取消授权
    authorFn(row) {
      console.log(row);
      this.isPower = row.is_power;
      this.distributorTwoId = row.DistributorID;
      if (this.isPower == 1) {
        this.authorCancleDialogVisible = true;
      }
      if (this.isPower == 2) {
        this.authorSureDialogVisible = true;
      }
    },
    // 二级授权取消
    authorCancleTwoFn() {
      this.authorSureDialogVisible = false;
    },
    // 点击授权关闭弹框X
    autorSureHandleClose() {
      this.authorSureDialogVisible = false;
    },
    // 授权弹框
    autor(row) {
      console.log(row);
      this.distrbutorId = row.DistributorID;
      this.scenicName = row.Name;
      this.authorPar = {
        token: this.Token,
        distrbutor_id: row.DistributorID,
        page: 1,
        page_size: 8
      };
      this.getList(this.authorPar);
      this.authorDialogVisible = true;
    },
    // 获取授权列表数据
    getList(data) {
      getDistrbutorTwoListPost(data).then(res => {
        console.log(res);
        this.authorData = res.data.result.data;
        this.total = res.data.result.total;
      });
    },
    // 授权关闭弹框X
    authorHandleClose() {
      this.authorDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      // console.log(val);
      this.authorPar.page = val;
      this.getList(this.authorPar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
    height: 266px;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}

.titleName {
  width: 250px;
  height: 20px;
  > span:nth-child(1) {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  }
  > span:nth-child(2) {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #000;
    margin-left:0.8rem;
  }
}
.unaudite {
  color: #ff4d4f;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-pagination{
  display: flex;
  flex-wrap: wrap;
}
.divider_flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.inpt{
  display: flex;
  justify-content: space-between;
  button{
    margin-left: 10px;
  }
}
/deep/ .el-dialog__title{
  font-weight: 400 !important;
  color: #000 !important;
  font-family: OPPOSans !important;
  font-size: 2rem !important;
}
</style>